import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal,
} from "pbas-vue-components";

var SickPaymentLimitsHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    isIdentifier: true,
  }),
  new InMemoryHeader({
    title: "headers.sick_payment_settings.upper_boundary",
    type: new InMemoryDecimal("UpperBoundary",{
      getString: (item, type) => {
        if (item.UpperBoundary === null || item.UpperBoundary === undefined) {
          return '\u221e'.toString();
        }
        return (parseFloat(item.UpperBoundary)).toFixed(2);
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: true,
  }),
  new InMemoryHeader({
    title: "headers.sick_payment_settings.limits",
    type: new InMemoryDecimal("AmountPerSickDay", {
      getString: (item, type) => {
        return (parseFloat(item.AmountPerSickDay)).toFixed(2) +"$";
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: true,
  }),
];

export default SickPaymentLimitsHeaders;
